import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { HlmSidebarImports } from '@spartan-ng/helm/sidebar';
import { HlmButtonImports } from '@spartan-ng/helm/button';
import { HlmSeparatorImports } from '@spartan-ng/helm/separator';
import { HlmAlertDialogImports } from '@spartan-ng/helm/alert-dialog';
import { HlmBadgeImports } from '@spartan-ng/helm/badge';
import { BrnAlertDialogImports } from '@spartan-ng/brain/alert-dialog';
import { NgIcon, provideIcons } from '@ng-icons/core';
import {
  lucideLayoutDashboard,
  lucideLogOut,
  lucideUser,
  lucideSettings,
  lucidePanelLeft,
  lucideFileText,
  lucideShieldCheck,
} from '@ng-icons/lucide';
import { Auth } from '../../services/auth';
import { FooterComponent } from '../../components/footer/footer.component';

@Component({
  selector: 'app-dashboard-main',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    ...HlmSidebarImports,
    ...HlmButtonImports,
    ...HlmSeparatorImports,
    ...HlmAlertDialogImports,
    ...HlmBadgeImports,
    BrnAlertDialogImports,
    NgIcon,
    FooterComponent,
  ],
  providers: [
    provideIcons({
      lucideLayoutDashboard,
      lucideLogOut,
      lucideUser,
      lucideFileText,
      lucideSettings,
      lucidePanelLeft,
      lucideShieldCheck,
    }),
  ],
  templateUrl: './dashboard-main.html',
  styleUrl: './dashboard-main.css',
})
export class DashboardMain {
  private auth = inject(Auth);
  private router = inject(Router);

  logout(): void {
    this.auth.logout();
    this.router.navigate(['/login']);
  }
}
